import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { api, type Me } from './api';
import NavRail from './components/NavRail';
import Topbar from './components/Topbar';
import Login from './pages/Login';
import Chat from './pages/Chat';
import Admin from './pages/Admin';
import Conversations from './pages/Conversations';
import Ventes from './pages/Ventes';
import Stocks from './pages/Stocks';
import Lots from './pages/Lots';
import Achats from './pages/Achats';
import Accueil from './pages/Accueil';
import Journal from './pages/Journal';
import Dashboard from './pages/Dashboard';

type Theme = 'light' | 'dark';

export default function App() {
  const [me, setMe] = useState<Me | null | undefined>(undefined);
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem('stm-theme') as Theme) || 'light',
  );

  function refresh() {
    api.me().then(setMe).catch(() => setMe(null));
  }
  useEffect(refresh, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('stm-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === 'light' ? 'dark' : 'light'));

  if (me === undefined) return <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>Chargement…</div>;

  if (!me) {
    return (
      <Routes>
        <Route path="*" element={<Login onLogin={refresh} />} />
      </Routes>
    );
  }

  return (
    <div className="app-shell">
      <NavRail me={me} onLogout={() => setMe(null)} theme={theme} onToggleTheme={toggleTheme} />
      <div className="app-main">
        <Topbar />
        <div className="app-scroll">
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/tableaux" element={<Dashboard />} />
          <Route path="/chat" element={<Chat me={me} />} />
          <Route path="/ventes" element={<Ventes />} />
          <Route path="/stocks" element={<Stocks />} />
          <Route path="/lots" element={<Lots />} />
          <Route path="/achats" element={<Achats />} />
          <Route path="/journal" element={<Journal />} />
          {/* Anciennes URLs → onglets de la page Ventes (préserve le bookmark /devis). */}
          <Route path="/devis" element={<Navigate to="/ventes?tab=devis" replace />} />
          <Route path="/commandes" element={<Navigate to="/ventes?tab=commandes" replace />} />
          <Route path="/factures" element={<Navigate to="/ventes?tab=factures" replace />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/admin" element={me.is_admin ? <Admin /> : <Navigate to="/" />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        </div>
      </div>
    </div>
  );
}
